
import { create } from "zustand";

interface UploadStore {
    show: boolean;
    files: File[];
    urls: string[];
    ids: string[];
    totalProgress: number;
    fileUploadProgress: number[];
    onResetCallback: (() => void) | null;
    setFiles: (files:File[]) => void,
    setUrls: (urls:string[]) => void,
    setIds: (ids:string[]) => void,
    setShow: (show:boolean) => void,
    setOnResetCallback: (fn: (() => void) | null) => void;
    setFileUploadProgress: (index: number, progress: number) => void;
    reset: () => void;
}

export const useUploadStore = create<UploadStore>(set => ({
    show: false,
    files: [],
    urls: [],
    ids: [],
    totalProgress: 0,
    fileUploadProgress: [],
    onResetCallback: null, 
    setFiles: (files) => set({ files }),
    setUrls: (urls) => set({ urls }),
    setIds: (ids) => set({ ids }),
    setShow: (show) => set({ show }),
    setOnResetCallback: (fn) => set({ onResetCallback: fn }),
    setFileUploadProgress: (index, progress) => {
        set((state) => {
            const arr = [...state.fileUploadProgress];
            arr[index] = progress;
            return { fileUploadProgress: arr }; 
        });
        set((state) => { 
            const total = state.fileUploadProgress.reduce((a, b) => a + b, 0) / state.fileUploadProgress.length;
            return { totalProgress: total };
        });
    },
    reset: () => set((state) => {
        const cb = state.onResetCallback;
        window.setTimeout(() => cb && cb(), 0);
        return {
            show: false,
            files: [],
            urls: [],
            ids: [], 
            totalProgress: 0,
            fileUploadProgress: [],
            onResetCallback: null
        };
    })
}));